var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4645 3.6259C14.7544 3.92174 15.2292 3.92655 15.5251 3.63664C15.8209 3.34673 15.8257 2.87188 15.5358 2.57604C14.13 1.14149 12.1686 0.25 10.0002 0.25C5.71998 0.25 2.25019 3.71979 2.25019 8L0.80014 8C0.470522 8 0.28237 8.37631 0.48014 8.64L2.68014 11.5733C2.84014 11.7867 3.16014 11.7867 3.32014 11.5733L5.52014 8.64C5.71791 8.37631 5.52976 8 5.20014 8L3.75019 8C3.75019 4.54822 6.54841 1.75 10.0002 1.75C11.7492 1.75 13.3292 2.4674 14.4645 3.6259ZM16.6801 4.42667L14.4801 7.36C14.2824 7.62369 14.4705 8 14.8001 8L16.2501 8C16.2501 11.4518 13.4519 14.25 10.0001 14.25C8.25115 14.25 6.67108 13.5326 5.53582 12.3741C5.24591 12.0782 4.77106 12.0734 4.47522 12.3633C4.17937 12.6532 4.17455 13.1281 4.46446 13.4239C5.87023 14.8585 7.83175 15.75 10.0001 15.75C14.2803 15.75 17.7501 12.2802 17.7501 8L19.2001 8C19.5298 8 19.7179 7.62369 19.5201 7.36L17.3201 4.42667C17.1601 4.21333 16.8401 4.21333 16.6801 4.42667Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.59527411a9972355ea391c87811b11b0.svg";
export { ForwardRef as ReactComponent };